// extracted by mini-css-extract-plugin
module.exports = {"Modal":"ModalSuccess_Modal__3_pfc","ModalBody":"ModalSuccess_ModalBody__1lRJk","Button__Close":"ModalSuccess_Button__Close__Invzr"};